import React from "react";
import { withRouter } from 'react-router';
import Land from './LandingPage/Landing.js';

const LandingPage = ({history}) => (
  <div> 
    {/* {console.log(history)} */}
    {/* {history.push("./numbers")} */}
    <Land/>
    {/* <h1>This is the landing page</h1>
    <a class="waves-effect waves-light btn"><i class="material-icons right">cloud</i>button</a> */}
  </div>
);

// class LandingPage extends React.Component {
//   componentWillMount(){
    
//   }
//   render() {
//     return <p>Redirecting...</p>;
//   }
// }

export default withRouter(LandingPage);
